import { HeaderModel } from '@/types';
import Menu from '@/assets/menu.svg';
import XLight from '@/assets/xLight.svg';
import classNames from 'classnames';
import Stack from '../animation/Stack';
import { animController, fadeIn, fadeInLeft } from '@/animations';
import Link from '../general/Link';
import Box from '../animation/Box';
import LoginLogoutBtn from './LoginLogoutBtn';
import { usePathname } from 'next/navigation';

type MobileNavModel = {
  data: HeaderModel;
  open: boolean;
  toogleOpen: () => void;
  className?: string;
};

const MobileNav = ({ data, open, toogleOpen, className }: MobileNavModel) => {
  const pathname = usePathname();
  return (
    <div className={className}>
      <button
        className={classNames(
          'bg-yellow align-center flex h-8 w-8 items-center justify-center rounded-full',
          className,
        )}
        onClick={toogleOpen}
      >
        {open ? <XLight className="h-6 w-6" /> : <Menu className="fill-black" />}
      </button>

      <div
        className={classNames(
          'absolute top-[var(--header-height)] right-0 w-full overflow-hidden transition-all duration-0 ease-out',
          open ? 'h-[calc(100dvh-var(--header-height))]' : 'h-0 delay-500',
        )}
      >
        <div
          className={classNames(
            'h-full bg-white transition-all duration-500 ease-out',
            open ? 'opacity-100' : 'opacity-0',
          )}
        >
          <div className="container flex h-full flex-col items-center justify-center">
            <Stack className="flex h-full flex-col justify-around gap-5" animation={animController(open)}>
              <div className="flex flex-col gap-3">
                {data.links.map((link, index) => {
                  const className = classNames(
                    'w-full p-3 text-center text-2xl font-bold flex justify-center items-center',
                    pathname === link.props.link?.href && 'bg-[#e9e3e3]  rounded-3xl',
                  );

                  return link.props.link ? (
                    <Link animate animation={fadeInLeft} link={link.props.link} key={index} className={className}>
                      {link.props.label}
                    </Link>
                  ) : (
                    <Box animation={fadeInLeft} key={index} className={className}>
                      {link.props.label}
                    </Box>
                  );
                })}
              </div>
              <div className="flex flex-col gap-5">
                {data.highlightedButton && (
                  <Link
                    animate
                    animation={fadeIn}
                    link={data.highlightedButton}
                    className="btn primary !bg-yellow !border-yellow w-full !px-5 !py-2.5 !text-sm !font-normal !text-black"
                  />
                )}
                {(data.loginLink || data.logoutLink) && (
                  <Box animation={fadeIn} className="w-full">
                    <LoginLogoutBtn
                      loginLink={data.loginLink}
                      logoutLink={data.logoutLink}
                      className="w-full !text-sm !font-normal"
                    />
                  </Box>
                )}
              </div>
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
